import styled, {css} from 'styled-components';

export const Container = styled.div`
    position: sticky;
    bottom: 0;
    background-color: rgb(44, 62, 80);
    color: white;
    padding: 20px;
`;


export const Text = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    ${props => props.marginLeft
        ? `marginLeft: ${props.marginLeft}`
        : ``
    }
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;

export const Button = styled.button`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    flex: 0 0 auto;
    padding: 10px 20px;
    font-size: 0.8em;
    font-weight: bold;
`